import colors from "core/resources/theme/colors";
import styled from "styled-components";

export const InputContainer = styled.div<any>`
  .chakra-input:hover,
  .chakra-input:focus {
    border-color: ${(props) => (props.isInvalid ? colors.red : colors.primary)} !important;
    box-shadow: 0 0 0 1px ${(props) => (props.isInvalid ? colors.red : colors.primary)} !important;
    outline-color: ${(props) => (props.isInvalid ? colors.red : colors.primary)};
    transition: all .2s;
  }

  .chakra-input {
    border-radius: 6px;
    padding: 9px 16px;
    width: 100%;
    border-width: 1px;
    border-style: solid;
    border-color: ${(props) => (props.isInvalid ? colors.red : colors.blue100)} !important;
    background-color: ${(props) => (props.isInvalid ? colors.red100 : colors.blue100)} !important;
  }
`;
